import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { pnlDownloadDate, previousDay } from "@domains/utils/reportDates";
const CustomDateRange = (props) => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = React.useState();
    const [selectedDateRange, setSelectedDateRange] = useState("startDateSelected");
    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        setSelectedDateRange(end ? "startDateSelected" : "endDateSelected");
    };
    const handleApplyButtonClick = () => {
        if (props.setSelectedStartDate)
            props.setSelectedStartDate(startDate);
        if (props.setSelectedEndDate)
            props.setSelectedEndDate(endDate);
        props.setDateDrawer(false);
    };
    useEffect(() => {
        setStartDate(props.selectedStartDate);
        setEndDate(props.selectedEndDate);
    }, []);
    return (React.createElement("div", { className: "px-3 common-datepicker pt-2" },
        React.createElement("div", { className: "pandLcalendar txn-mob-custom-calender" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12 col-lg-12 pandLcalendar-form" },
                    React.createElement("div", { className: "row calendar--row" },
                        React.createElement("div", { className: `col pdr-0 DMSans_16_500 ${selectedDateRange === "startDateSelected"
                                ? "txt-midight-blue"
                                : "txt-secondary-gray"}` },
                            React.createElement("label", { htmlFor: "" }, "From Date"),
                            React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate" },
                                React.createElement("input", { type: "text", className: `form-control 
                    ${selectedDateRange === "startDateSelected"
                                        ? "txt-midight-blue"
                                        : "txt-secondary-gray"}
                    `, placeholder: "DD-MMM-YY", value: moment(startDate).format("D-MMM-YY"), readOnly: true }),
                                React.createElement("span", { className: "input-group-text" },
                                    React.createElement("i", { className: "edel-icon-calendar-report" })))),
                        React.createElement("div", { className: `col pdl-0  DMSans_16_500 col pdl-0 ${selectedDateRange === "endDateSelected"
                                ? "txt-midight-blue"
                                : "txt-secondary-gray"}` },
                            React.createElement("label", { htmlFor: "", className: "" }, "To Date"),
                            React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate" },
                                React.createElement("input", { type: "text", className: `form-control 
                    ${selectedDateRange === "endDateSelected"
                                        ? "txt-midight-blue"
                                        : "txt-secondary-gray"}
                    `, placeholder: "DD-MMM-YY", value: selectedDateRange === "endDateSelected"
                                        ? "Select End Date"
                                        : moment(endDate).format("D-MMM-YY"), readOnly: true }),
                                React.createElement("span", { className: "input-group-text" },
                                    React.createElement("i", { className: "edel-icon-calendar-report" }))))),
                    React.createElement("div", { className: "yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer arrows-in-yeardrop custom-date-range-calender" },
                        React.createElement(DatePicker, { dateFormat: "d-MMM-yy", onChange: onChange, startDate: startDate, endDate: endDate, selectsRange: true, inline: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), showYearDropdown: true, showMonthDropdown: true, scrollableYearDropdown: true, useShortMonthInDropdown: true, selected: startDate, minDate: pnlDownloadDate, maxDate: previousDay })))),
            React.createElement(Row, { className: "bottombtnsection mb-2 \u00A0pt-3 bg-white" },
                React.createElement(Col, { lg: 6, xs: 6, className: "ps-3" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100 mt-3 mb-3", onClick: () => props.setDateDrawer(false) })),
                React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100 mt-3 mb-3", onClick: handleApplyButtonClick }))))));
};
export default CustomDateRange;
